const en = {
	Credentials: "Credentials",
	Logout: "Logout",
	"My Credentials": "My Credentials",
	"Issue Date": "Issue Date",
	By: "By",
	View: "View",
	Verify: "Verify",
	purchase_for: "Purchase for ",
	"Terms of Service": "Terms of Service",
	"Privacy & Data Protection": "Privacy & Data Protection",
	"Customer Support": "Customer Support",
	"Help Center": "Help Center",
	"Verify Certificate": "Verify Certificate",
	"View Certificate": "View Certificate",
	Inbox: "Inbox",
	"Open Issuers App": "Open Issuers App",
	Name: "Name",
	"You are purchasing": "You are purchasing",
	"Payment info": "Payment info",
	Email: "Email",
};
export default en;
